module.exports = __webpack_public_path__ + "img/sj@3x.d31f6356.png";